export const INSTANT_TRANSFER_ACCESS_LOST_HELP_ARTICLE_URL =
  'https://support.superdispatch.com/hc/en-us/articles/49259409682579-Instant-Transfer-What-Does-Instant-Transfer-Access-Lost-Mean-and-How-to-Regain-Access';
